import { render, staticRenderFns } from "./UserGroupList.vue?vue&type=template&id=67b63efe&scoped=true"
import script from "./UserGroupList.vue?vue&type=script&lang=js"
export * from "./UserGroupList.vue?vue&type=script&lang=js"
import style0 from "./UserGroupList.vue?vue&type=style&index=0&id=67b63efe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b63efe",
  null
  
)

export default component.exports